// 電腦ip查詢
import { Component, Injector, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { idNameItem, JkBaseOption, MaterialModule, PageKind, } from 'jk-service';
import { AdvComModule, jkQueryComponent, } from 'jk-advcom';
import { JackBaseComponentModule } from 'jk-service';


export class Utypq01Option extends JkBaseOption { // ###
  mc020 = '';// customId
  mc011: string = '';// 電腦名稱(部份)
  mc003: string = '';
  mc009: string = '';
  mc013: string = '';
  orderBy: string = 'ORDER BY MC011';

}

@Component({
  standalone: true,
  selector: 'app-utypq01',
  templateUrl: './utypq01.component.html',
  imports: [MaterialModule, JackBaseComponentModule, AdvComModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [],
  //styleUrls: ['./utypq01.page.scss'],
})
export class Utypq01Component extends jkQueryComponent implements OnInit {
  override _programId = 'utypq01'; // ###
  filterOpt: Utypq01Option = new Utypq01Option(this.programId);//###
  orderList: idNameItem[] = [{ 'id': 'ORDER BY MC011', 'name': '電腦名稱' }, { 'id': 'ORDER BY MC009', 'name': '內部IP' }];
  //customIdList = customIdList;
  customIdList: idNameItem[] = [{ id: '', name: '全部' }, { id: 'JACK', name: '傑克' }, { id: 'AJM', name: '璦之夢' }];

  constructor() {
    super();
    this.setFormOpt2();//###
  }
  override ngOnInit() {
    super.ngOnInit();
  }
  override async ngAfterViewInit() {
    super.ngAfterViewInit();
    // UTYPQ01-S01

    //this.stklg001.edA.value = jkLib.countDate(jkLib.nowDate(),'D',-120);
    //this.stklg001.edB.value = jkLib.nowDate();
    //this.stkma001List = await jkOpenWin.doOpenWin<idNameItem[]>('S','#STKMA001','V01',[]);
    //this.stkma019.value = '0';
    //this.stklg002.value = '日線';
    //this.masterGridSet.init(this.masterGrid, this.qryMaster);
    //this.detailGridSet.init(this.detailGrid, this.qryDetail as JkEntity);
    //this.titlebar.onUser1Click = this.doRefresh;
    //this.titlebar.user1Text = '重新顯示';


    try {
      //await this.masterLookup.init();
    } catch (error) {

    }
    this.checkAllInit(this);// 這行要放在 ngAfterViewInit 最後  ###

  }
  ngOnExit() {
  }

  override async beforeQuery(): Promise<boolean> {
    await super.beforeQuery();
    //await this.masterGrid.init(this.programId,'S01','S',['LG001','LG002','LG003','LG004'],[]);
    this.gridInitOpt = {
      pageKind: PageKind.report,
      programId: this.programId,
      sortField: '',
      sort: 'asc',
      defaultSort: null,
    };
    this.type = 'S';
    this.winItem = 'S01';
    this.mainTable = this.programId; //['LG001','LG002','LG003','LG004'];
    this.where = '';
    //this.where = this.stklg001.addWhere(this.where,'LG001');
    this.order = this.filterOpt.orderBy;
    return true;


  }

  // ### [以上是必要的]================================

}
